import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import ButtonLink from '@/components/base/ButtonLink';
import Reveal from '@/components/base/Reveal';

const details = [
  { label: 'Preventive', text: 'Seasonal inspections, filter changes, roof and drainage checks, life-safety testing.' },
  { label: 'Reported issues', text: 'Logged on receipt, routed to the right vendor and followed until closed.' },
  { label: 'Updates', text: 'Residents hear what happens next while a request is open.' },
];

export default function MaintenanceFeature() {
  return (
    <Section labelledBy="preventive-heading">
      <Container>
        <div className="grid grid-cols-1 items-center gap-8 md:gap-10 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="mb-3 font-label text-[12px] font-semibold uppercase tracking-[0.14em] text-accent-500 md:text-[13px]">
                Maintenance &amp; response
              </p>
            </Reveal>
            <Reveal delay={100}>
              <h2 id="preventive-heading" className="font-heading text-[28px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] md:text-[34px] lg:text-[38px]">
                Preventive care first, quick follow-up when something breaks.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-5 text-[16px] leading-[1.62] text-foreground-700">
                Most building problems are cheaper and less disruptive when caught early. When a resident reports a leak or a broken light, we make sure it gets resolved.
              </p>
            </Reveal>
            <dl className="mt-7 border-t border-background-200">
              {details.map((d) => (
                <div key={d.label} className="grid grid-cols-1 gap-1 border-b border-background-200 py-4 sm:grid-cols-[130px_1fr] sm:gap-4">
                  <dt className="text-[13px] font-semibold uppercase tracking-[0.08em] text-[#222222]">{d.label}</dt>
                  <dd className="text-[15px] leading-[1.55] text-foreground-700">{d.text}</dd>
                </div>
              ))}
            </dl>
            <div className="mt-7">
              <ButtonLink to="/contact?type=resident" variant="text">How residents report an issue</ButtonLink>
            </div>
          </div>
          <div className="lg:col-span-7">
            <Reveal variant="wipe" delay={150}>
              <div className="aspect-[4/3] w-full overflow-hidden rounded-[12px] bg-background-100 lg:aspect-auto lg:h-[480px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/6aa336ad-c8e8-4ab1-9b2c-ef8438caec0f_maint-fixed.webp"
                  alt="Maintenance technician checking an entrance light at a residential building"
                  title="Residential maintenance and response - COMMON Property Management"
                  className="h-full w-full object-cover object-center"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </Container>
    </Section>
  );
}